import { useToast } from "@teamworksdev/react";
import { useCallback } from "react";

export const useApiError = () => {
  const { toast } = useToast();

  const onApiError = useCallback(
    (err: unknown) => {
      if (err instanceof Error) {
        toast({
          variant: "destructive",
          title: "API Error",
          description: err.message,
        });
      }
    },
    [toast],
  );

  return { onApiError };
};
